require ('./dist/angular-ui-swiper');
module.exports = 'ui.swiper';
